
import { makeRequest } from 'utils/requestLogger';

export default (roundtable_id, job_id) =>
    makeRequest(
        'get',
        `/api/roundtables/${roundtable_id}/grade-classroom-students/job/${job_id}`
    );



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/gradeGoogleClassroomStudentsJobStatus.js